import type { SagaMiddleware } from "redux-saga";
import { all, spawn } from "redux-saga/effects";
import authSaga from "@pd/redux/sagas/auth";
// import buyerPortalModalSaga from "@pd/layouts/BuyerPortal/redux/sagas/modalManager";
import { isBuyerCredit, isMerchantDash } from "@pd/utils/appCheck";
import buyerCreditSaga from "@pd/layouts/BuyerCredit/redux/sagas";
import dashboardSaga from "../../layouts/MktplaceDashboard/redux/sagas/index";
import plaidLinkSagas from "../../components/PlaidLink/redux/sagas";

function getSagasByApp() {
  // if (isBuyerPortal()) {
  //   return [authSaga, plaidLinkSagas, buyerPortalModalSaga];
  // }
  if (isBuyerCredit()) {
    return [authSaga, plaidLinkSagas, buyerCreditSaga];
  }
  if (isMerchantDash()) {
    return [authSaga, plaidLinkSagas, dashboardSaga];
  }
  return [];
}

const sagas = getSagasByApp();

function* rootSaga() {
  yield all(sagas.map((saga) => spawn(saga)));
}

export default function initSagas(sagaMiddleware: SagaMiddleware) {
  sagaMiddleware.run(rootSaga);
}
